import type { CompensationRecord } from '../../../services/adminService';
import { formatMoney, formatSti } from '../../../services/adminService';
import type { AdminColumnDef } from './adminColumnVisibility';

/** FIX / STI / LTIP для таблиц записей в админке (список + грейдирование). */
export const recordCompensationColumns: AdminColumnDef<CompensationRecord>[] = [
  {
    id: 'fix',
    label: 'FIX',
    dbField: 'compensation_record_base.base_gross_salary',
    render: (record) => formatMoney(record.fix),
  },
  {
    id: 'sti',
    label: 'STI',
    dbField: 'compensation_record_sti.sti_target_pct',
    render: (record) => formatSti(record.sti),
  },
  {
    id: 'ltip',
    label: 'LTIP',
    dbField: 'compensation_record_ltip',
    render: (record) => record.ltip ?? (record.ltip_has ? 'да' : '—'),
  },
];
